import { formatPrice } from '@petsmart-ui/sparky';

export function formatCurrency(num?: number, removeCents = false): string {
    return formatPrice(num ?? 0, 'USD', 'en-US', 'currency', removeCents);
}
